import generateNavItems from "./generateNavItems";

export default generateNavItems;
